import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

interface ItemCardMinimumOrderProps {
  count: number;
}

export const ItemCardMinimumOrder = ({ count }: ItemCardMinimumOrderProps) => {
  return <MinimumOrderText>(최소 구매수량 &#58; {count}개)</MinimumOrderText>;
};

const MinimumOrderText = styled.span`
  margin: 0 0 0 2px;
  height: 14px;
  font-weight: 400;
  font-size: 12px;
  color: ${vars.v3Color.gray400};
`;
